import {Injectable} from "@angular/core";
import {environment} from "../environments/environment";


@Injectable({
    providedIn: 'root'
})
export class ConfigService {
    public authApi = environment.apiEndPoint + '/user/auth';
    public userApi = environment.apiEndPoint + '/user';
    public searchApi = environment.apiEndPoint + '/search';
    public registryApi = environment.apiEndPoint + '/crawl-data-registry/resources';
    public crawlApi = environment.apiEndPoint + '/crawl-cycle';
}
